// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderInvoice_container__2WRBj","scrollContainer":"OrderInvoice_scrollContainer__270L4"};